import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/usage/scope/usage.scopeTenant.query.gql"
import type {
  UsageScopeTenantQuery,
  UsageScopeTenantQueryVariables,
} from "@/v2-backoffice-client/usage/scope/__types__/usage.scopeTenant.query"

type Options = QueryHookOptions<
  UsageScopeTenantQuery,
  UsageScopeTenantQueryVariables
>

export function useUsageScopeTenantQuery(options?: Options) {
  return useQuery<UsageScopeTenantQuery, UsageScopeTenantQueryVariables>(
    query,
    options,
  )
}
